import React from 'react';
import { StyledModal } from './StyledModal';

type ResetPasswordEmailSendedProps = {
  isOpen: boolean,
  close: () => void
}

export const ResetPasswordEmailSended = ({isOpen, close} : ResetPasswordEmailSendedProps) => {
  return(
    <StyledModal 
      title="Инструкция по сбросу пароля отправлена" 
      open={isOpen}
      onCancel={close}
      footer={[]}
    >
        <p>Инструкция по сбросу пароля успешно отправлена, проверьте, пожалуйста, Вашу почту.</p>
        <p style={{marginTop: '10px'}}>Если письмо не приходит, проверьте папку &quot;Спам&quot;.</p>
    </StyledModal>
  )
}